// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react'
import Header from '../header/Header'
import Container from '../../common/container/Container'
import { i18n } from '../index'
import { withRouter, Switch } from 'react-router-dom'
import ScoreCard from './ScoreCard'
import css from './scoreCard.css'
import { inject } from 'mobx-react'
const BASE_PATH = '/tuloskortti'
type ScoreCardPageProps = {
  history: Record<string, any>
  location: Record<string, any>
}

@inject('stationStore')
class ScoreCardPage extends React.Component<ScoreCardPageProps> {
  tabs = [
    {
      label: i18n.t('scoreCard.tab.station'),
      value: this.props.stationStore.activeStationId,
    },
    {
      label: i18n.t('scoreCard.tab.chain'),
      value: '',
      requiredPermission: 'manage_chain',
    },
  ]
  onTabClick = (tab) => {
    const { history } = this.props
    history.push(`${BASE_PATH}/${tab.value}`)
  }
  getActiveTab = () => {
    const {
      match: { params },
    } = this.props
    return params.stationId || ''
  }

  render() {
    return (
      <div className={css.component}>
        <Header
          title={i18n.t('scoreCard.title')}
          tabs={this.tabs}
          tabActive={this.getActiveTab()}
          onTabClick={this.onTabClick}
        />
        <Container>
          <Switch>
            <ScoreCard />
          </Switch>
        </Container>
      </div>
    )
  }
}

export default withRouter(ScoreCardPage)
